import { RootState } from "../../index";

export const requirementsSelector = (state: RootState) => {
  return state.requirementList.requirements;
};

export const selectedFilterSelector = (state: RootState) => {
  return state.requirementList.selectedStatus;
};

export const isLoadingSelector = (state: RootState) => {
  return state.requirementList.isLoading;
};

export const currentPageSelector = (state: RootState) => {
  const currentPage = state.requirementList.pageIndex;
  return currentPage;
};

export const numberOfRequirementsSelector = (state: RootState) => {
  return state.requirementList.amountOfRequirements;
};
